module.exports = __webpack_public_path__ + "img/sun.d6c5298c.png";